import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const GmailConexion = () => {
  const [s, setS] = useState(null);
  const [sp, setSp] = useSearchParams();
  const load = () => api.get("/gmail/status").then((r) => setS(r.data));
  useEffect(() => {
    load();
    const g = sp.get("gmail");
    if (g) {
      if (g === "ok") toast.success("Gmail del centro conectado");
      else toast.error(`No se pudo conectar Gmail. Inténtalo de nuevo.${sp.get("motivo") ? ` (${sp.get("motivo")})` : ""}`, { duration: 15000 });
      setSp({}, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const conectar = async () => {
    try {
      const { data } = await api.get("/gmail/connect");
      window.location.href = data.url;
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const desconectar = async () => {
    if (!window.confirm("¿Desconectar el Gmail del centro? Los presupuestos se abrirán en tu programa de correo.")) return;
    await api.post("/gmail/disconnect");
    load();
  };
  const sincronizar = async () => {
    try {
      const { data } = await api.post("/gcal/sync");
      toast.success(`${data.enviadas} citas pasadas a Google Calendar${data.errores ? ` · ${data.errores} con error` : ""}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!s) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm" data-testid="gmail-conexion">
      <Mail className="h-4 w-4 text-slate-500" />
      {!s.configurado && <span className="text-slate-500" data-testid="gmail-no-config">Falta configurar las claves de Google para poder conectar el Gmail del centro.</span>}
      {s.configurado && !s.conectado && <>
        <span className="text-slate-600">Conecta la cuenta Gmail del centro para enviar los presupuestos y pasar las citas a Google Calendar.</span>
        <button onClick={conectar} data-testid="gmail-connect-btn" className="rounded-md bg-[#1E3A8A] text-white px-3 py-1.5">Conectar Gmail y Calendar</button>
      </>}
      {s.conectado && <>
        <span className="text-emerald-700" data-testid="gmail-conectado">Conectado: {s.email || "cuenta Gmail del centro"}</span>
        {s.calendario && s.borradores
          ? <><span className="text-emerald-700" data-testid="gcal-on">· Borradores y Google Calendar activos</span>
            <button onClick={sincronizar} data-testid="gcal-sync-btn" className="rounded-md border border-slate-300 px-3 py-1.5">Pasar citas futuras al calendario</button></>
          : <button onClick={conectar} data-testid="gcal-connect-btn" className="rounded-md bg-[#1E3A8A] text-white px-3 py-1.5">Volver a conectar Google (faltan permisos)</button>}
        <button onClick={desconectar} data-testid="gmail-disconnect-btn" className="rounded-md border border-slate-300 px-3 py-1.5">Desconectar</button>
      </>}
    </div>
  );
};
